export default (data, resolve, self) => {
  self.appearHero(resolve);
}
